import React, { useEffect, useRef } from 'react'
import Select from 'react-select'

import 'react-select/dist/react-select.css'

const SELECTS = require('../Datas/Selects')

const AgendaFormFilterQuartiers = ({OnChangeFilterQuartier, AgendaFilterActiveQuartier}) => {
	const selectRef = useRef(null)
	// Validation des props et gestion des erreurs
	if (typeof OnChangeFilterQuartier !== 'function') {
		return (
			<div role="region" aria-label="Filtre de quartiers d'événements" className="agenda-form-filter-quartiers-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : fonction de changement de filtre manquante ou invalide</p>
				</div>
			</div>
		)
	}

	// Validation des données de sélection
	if (!SELECTS || !SELECTS['quartiers'] || !Array.isArray(SELECTS['quartiers'])) {
		return (
			<div role="region" aria-label="Filtre de quartiers d'événements" className="agenda-form-filter-quartiers-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : données de quartiers manquantes ou invalides</p>
				</div>
			</div>
		)
	}

	// Construction de l'aria-label pour le composant Select
	const selectLabel = "Sélectionner le quartier"
	const selectDescription = "Filtre pour sélectionner le quartier des événements à afficher dans l'agenda"

	// Effet pour ajouter le rôle listbox au conteneur des options
	useEffect(() => {
		const updateSelectAccessibility = () => {
			if (typeof window === 'undefined' || !selectRef.current) return

			// Trouver le conteneur du menu des options de react-select
			// react-select crée une structure avec .Select-menu-outer contenant .Select-menu
			// Le menu peut être dans le conteneur ou dans document.body (portail)
			const menuContainer = document.querySelector('#react-select-4--value .Select-value')

			if (menuContainer) {
				// Ajouter le rôle listbox au conteneur des options
				menuContainer.setAttribute('role', 'listbox')
				menuContainer.setAttribute('id', 'agenda-filters-quartiers-listbox')
				menuContainer.setAttribute('aria-label', 'Tous les quartiers')
				
				// S'assurer que les options ont le bon rôle
				const options = menuContainer.querySelectorAll('.Select-option')
				options.forEach((option, index) => {
					if (!option.hasAttribute('role')) {
						option.setAttribute('role', 'option')
					}
					if (!option.hasAttribute('id')) {
						option.setAttribute('id', `agenda-filters-quartiers-option-${index}`)
					}
				})
			}

			// Trouver le contrôle principal (combobox)
			const control = selectRef.current.querySelector('.Select-control')
			if (control) {
				const input = control.querySelector('input')
				if (input) {
					// Ajouter aria-owns pour lier le combobox au listbox
					input.setAttribute('aria-owns', 'agenda-filters-quartiers-listbox')
					input.setAttribute('aria-haspopup', 'listbox')
					if (!input.hasAttribute('role')) {
						input.setAttribute('role', 'combobox')
					}
				}
			}
		}

		// Mettre à jour immédiatement
		updateSelectAccessibility()

		// Observer les changements du DOM pour mettre à jour quand le menu s'ouvre
		// Observer à la fois le conteneur et document.body (au cas où le menu est rendu en portail)
		const observer = new MutationObserver(() => {
			setTimeout(updateSelectAccessibility, 50)
		})
		
		if (selectRef.current) {
			observer.observe(selectRef.current, {
				childList: true,
				subtree: true,
				attributes: true,
				attributeFilter: ['class']
			})
		}

		// Observer aussi document.body au cas où le menu est rendu en portail
		const bodyObserver = new MutationObserver(() => {
			setTimeout(updateSelectAccessibility, 50)
		})
		
		bodyObserver.observe(document.body, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['class', 'role']
		})

		// Écouter les événements de clic et de focus pour mettre à jour quand le menu s'ouvre
		const handleInteraction = () => {
			setTimeout(updateSelectAccessibility, 100)
		}

		if (selectRef.current) {
			selectRef.current.addEventListener('click', handleInteraction)
			selectRef.current.addEventListener('focus', handleInteraction, true)
		}

		return () => {
			observer.disconnect()
			bodyObserver.disconnect()
			if (selectRef.current) {
				selectRef.current.removeEventListener('click', handleInteraction)
				selectRef.current.removeEventListener('focus', handleInteraction, true)
			}
		}
	}, [AgendaFilterActiveQuartier])

	return (
		<div role="group" aria-label="Filtre de quartiers d'événements" className="agenda-form-filter-quartiers-container">
			<label htmlFor="agenda-filters-quartiers" className="agenda-form-filter-quartiers-label visually-hidden">
				{selectLabel}
			</label>
			
			<div ref={selectRef}>
				<Select 
					id="agenda-filters-quartiers"
					className="generic-filters-select agenda-filters-select agenda-filters-select-quartiers" 
					name="agenda-filters-quartiers" 
					placeholder="Tous les quartiers" 
					options={SELECTS['quartiers']} 
					onChange={OnChangeFilterQuartier}
					value={AgendaFilterActiveQuartier}
					simpleValue
					clearable={false}
					searchable={false}
					aria-label={selectLabel}
					aria-describedby="agenda-form-filter-quartiers-description"
				/>
			</div>
			
			{/* Description accessible pour les lecteurs d'écran */}
			<div 
				id="agenda-form-filter-quartiers-description" 
				className="visually-hidden" 
				aria-live="polite"
			>
				{selectDescription}
			</div>

			{/* Message de statut pour les lecteurs d'écran */}
			<div 
				className="visually-hidden" 
				aria-live="polite" 
				aria-label="Statut du filtre de quartiers"
			>
				Filtre de quartiers chargé avec succès
			</div>
		</div>
	)
}

export default AgendaFormFilterQuartiers
